import React from 'react';

import { 
    TrashIcon
 } from "../../components";


const PaymentCard = ({data}) => {
    const { cards } = data;

    return (
        <>
            {cards.map((card, index) => (
                <div className="p-5 border border-gray-100 rounded-lg">
                    <div className="flex justify-between">
                        <div>
                            <img src={card.iconUrl} alt="Mastercard Icon" />
                        </div>
                        <div className="flex items-center">
                            <input type="radio" id="defaultCard" name="defaultCard" class="mr-2" />
                            <label for="defaultCard" class="font-redhat text-sm text-gray-800 font-medium">Set as default</label>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>
                            <p class="text-gray-800 text-sm font-redhat font-medium">{card.number}</p>
                            <p class="text-gray-600 text-sm font-redhat font-normal">Expiration Date: {card.expiration}</p>
                        </div>
                        <div>
                            <a href="#" class="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group">
                                <TrashIcon className="text-Gray-700" />
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default PaymentCard;